import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setTravelPolicyFormData, removeTravelPolicyFormData as removeTravelPolicyFormDataAction, selectTravelPolicyFormData } from '../redux/features/newTravelPolicyFormSlice';

const useBniTravelFormData = (formKey, setFormState) => {
    const dispatch = useDispatch();
    const travelFormData = useSelector(selectTravelPolicyFormData);

    const saveTravelDataInRedux = useCallback((data) => {
        dispatch(setTravelPolicyFormData({ key: formKey, data }));
        if (setFormState) {
            setFormState(data);
        }
    }, [dispatch, formKey, setFormState]);

    const removeTravelFormData = useCallback(() => {
        dispatch(removeTravelPolicyFormDataAction(formKey));
    }, [dispatch, formKey]);

    const getTravelFormData = useCallback(() => {
        return travelFormData[formKey] || null;
    }, [travelFormData, formKey]);

    return {
        saveTravelDataInRedux,
        removeTravelFormData,
        getTravelFormData,
        travelFormData,
    };
};

export default useBniTravelFormData;
